import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { bookAppointment } from '../services/scheduler.service';
import { BOOK_APPOINTMENT_MUTATION_KEY, PATIENT_PROFILE_QUERY_KEY } from '../constants';
import { BookAppointmentProps, BookAppointmentValues } from '../types';

export interface BookAppointmentValuesContext {
  previousValues: BookAppointmentValues;
}

function useMutationBookAppointment(
  onSuccess: () => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (props: BookAppointmentProps): Promise<any> => {
    return await bookAppointment(props);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (): Promise<void> => {
    void queryClient.invalidateQueries([PATIENT_PROFILE_QUERY_KEY]);
    onSuccess?.();
  };

  return useMutation<string, unknown, any, any>([BOOK_APPOINTMENT_MUTATION_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationBookAppointment;
